export const isEmail = (str) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,20}$/i.test(str);

export const containsNumber = (str) => /\d/.test(str);

export const containsLetter = (str) => /[a-z]/i.test(str);
